import { useState } from "react";
import emailjs from "@emailjs/browser";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default function Contact() {

  const [sending, setSending] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;

    const formData = {
      name: form.name.value,
      phone: form.phone.value,
      email: form.email.value,
      eventType: form.eventType.value,
      eventDate: form.eventDate.value,
      budget: form.budget.value,
      message: form.message.value
    };

    try {

      setSending(true);

      /* SAVE TO FIREBASE */

      await addDoc(collection(db, "enquiries"), {
        ...formData,
        createdAt: serverTimestamp()
      });

      /* SEND EMAIL USING EMAILJS */

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setSending(false);
      setSubmitted(true);

      form.reset();

    } catch (error) {
      console.error("Submission error:", error);
      setSending(false);
    }
  };

  return (
    <section id="contact">

      <div className="contact-grid">

        {/* LEFT SIDE */}

        <div className="contact-left">

          <div className="sec-label">Let's Talk</div>

          <h2 className="sec-title">
            Ready to plan your <em>perfect event?</em>
          </h2>

          <p className="contact-tagline">
            Tell us what you're celebrating and we'll make it beautiful —
            whatever your budget.
          </p>

        <div className="contact-details reveal reveal-delay-2">
        <div className="contact-item">
          <div className="contact-icon">📧</div>
          <div>
            <div className="contact-item-label">Email</div>
<div className="contact-item-val">
  <a href="mailto:info.archcrown@gmail.com" className="contact-link">
    info.archcrown@gmail.com
  </a>
</div>          </div>
        </div>
<div className="contact-item">
  <div className="contact-icon">📱</div>
  <div>
    <div className="contact-item-label">Phone / WhatsApp</div>
    <div className="contact-item-val">
      <a href="tel:+917702254457">+91 77022 54457</a><br />
      <a href="tel:+919618922550">+91 96189 22550</a><br />
      <a href="tel:+918143123500">+91 81431 23500</a>
    </div>
  </div>
</div>
        <div className="contact-item">
          <div className="contact-icon">📍</div>
          <div>
            <div className="contact-item-label">Based In</div>
            <div className="contact-item-val">Hyderabad, Telangana<br/>Available across Hyderabad &amp; surrounding areas</div>
          </div>
        </div>
        <div className="contact-item">
          <div className="contact-icon">💬</div>
          <div>
            <div className="contact-item-label">Free Consultation</div>
            <div className="contact-item-val">First meeting is always free. No commitments.</div>
          </div>
        </div>
      </div>

        </div>

        {/* RIGHT SIDE */}

        {!submitted ? (

          <form className="contact-form" onSubmit={handleSubmit}>

            <div className="form-row">

              <div className="form-group">
                <label>Your Name</label>
                <input
                  name="name"
                  type="text"
                  required
                />
              </div>

              <div className="form-group">
                <label>Phone / WhatsApp</label>
                <input
                  name="phone"
                  type="tel"
                  required
                />
              </div>

            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                name="email"
                type="email"
                required
              />
            </div>

            <div className="form-row">

              <div className="form-group">
                <label>Event Type</label>

                <select name="eventType" required>
                  <option value="">Select event</option>
                  <option>Wedding</option>
                  <option>Engagement</option>
                  <option>Birthday</option>
                  <option>Baby Shower</option>
                  <option>Housewarming</option>
                  <option>Corporate Event</option>
                </select>

              </div>

              <div className="form-group">
                <label>Event Date</label>
                <input
                  name="eventDate"
                  type="date"
                  required
                />
              </div>

            </div>

            <div className="form-group">
              <label>Budget</label>

              <select name="budget" required>
                <option value="">Budget range</option>
                <option>Under ₹50,000</option>
                <option>₹50k – ₹1L</option>
                <option>₹1L – ₹2.5L</option>
                <option>₹2.5L – ₹5L</option>
                <option>Above ₹5L</option>
              </select>

            </div>

            <div className="form-group">
              <label>Message</label>

              <textarea
                name="message"
                placeholder="Guests, venue, theme..."
                required
              ></textarea>

            </div>

            <button
              className="btn-submit"
              type="submit"
              disabled={sending}
            >
              {sending ? "Sending..." : "Send Enquiry"}
            </button>

          </form>

        ) : (

          <div className="contact-success">

            <div className="success-icon">✓</div>

            <h3>Enquiry Submitted</h3>

            <p>
              Thank you for contacting <b>Arch & Crown</b>.
              Our team will reach out to you shortly.
            </p>

          </div>

        )}

      </div>

    </section>
  );
}